import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreHotelExtra as restoreHotelExtraAPI } from "../../api/apiHotelExtras";
import parseError from "../../utils/parseError";

const useRestoreHotelExtra = () => {
    const queryClient = useQueryClient();

    const { mutate: restore, isPending: isRestoring } = useMutation({
        mutationFn: restoreHotelExtraAPI,
        onSuccess: (res) => {
            const message = res?.message || "Hotel extra restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelExtras"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore hotel extra");
        },
    });

    return { restoreHotelExtra: restore, isRestore: isRestoring };
};

export default useRestoreHotelExtra;
